var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('m-row',{staticClass:"mt-4"},[_c('m-col',{staticClass:"text-sm-right",attrs:{"cols":"9"}},[_c('p',[_vm._v(_vm._s(_vm.value.text))])]),_c('m-col',{attrs:{"cols":"3"}},[_c('p',[_vm._v(_vm._s(_vm.value.value))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }